import { isServer } from '../utils/isServer';
import {
  CUSTOMER_EMAIL,
  CUSTOMER_ID,
  CUSTOMER_ORDER,
  DEPRECATED_CUSTOMER_EMAIL,
  DEPRECATED_CUSTOMER_ID,
  DEPRECATED_CUSTOMER_ORDER,
} from './constants';

const getLocalItem = (key: string): string => {
  if (!isServer()) {
    const localValue = localStorage.getItem(key);
    return localValue !== null ? localValue : '';
  }

  return '';
};

export type CustomerData = {
  email: string;
  orderNumber: string;
  customerId: string;
};

const customerDetails = {
  getCustomerId(): string {
    const customerId = getLocalItem(CUSTOMER_ID);
    // for backwards compatibility
    if (customerId === '') {
      return getLocalItem(DEPRECATED_CUSTOMER_ID);
    }

    return customerId;
  },

  getCustomerEmail(): string {
    const customerEmail = getLocalItem(CUSTOMER_EMAIL);
    // for backwards compatibility
    if (customerEmail === '') {
      return getLocalItem(DEPRECATED_CUSTOMER_EMAIL);
    }

    return customerEmail;
  },

  getOrderNumber(): string {
    const customerOrderNumber = getLocalItem(CUSTOMER_ORDER);
    // for backwards compatibility
    if (customerOrderNumber === '') {
      return getLocalItem(DEPRECATED_CUSTOMER_ORDER);
    }

    return customerOrderNumber;
  },

  getCustomerDetails(): CustomerData {
    return {
      email: this.getCustomerEmail(),
      orderNumber: this.getOrderNumber(),
      customerId: this.getCustomerId(),
    };
  },

  setCustomerDetails(payload: Record<string, string>): void {
    if (!isServer()) {
      Object.entries(payload).forEach(([key, value]) => {
        localStorage.setItem(key, value);
      });
    }
  },

  clearCustomerDetails(): void {
    if (!isServer()) {
      localStorage.removeItem(CUSTOMER_EMAIL);
      localStorage.removeItem(CUSTOMER_ID);
      localStorage.removeItem(CUSTOMER_ORDER);

      // for backwards compatibility
      localStorage.removeItem(DEPRECATED_CUSTOMER_EMAIL);
      localStorage.removeItem(DEPRECATED_CUSTOMER_ID);
      localStorage.removeItem(DEPRECATED_CUSTOMER_ORDER);
    }
  },

  isCustomerAuthenticated(): boolean {
    const customerEmail = this.getCustomerEmail();
    const customerId = this.getCustomerId();
    const orderNumber = this.getOrderNumber();

    if (Boolean(customerEmail) && Boolean(customerId)) {
      return true;
    }

    if (Boolean(customerEmail) && Boolean(orderNumber)) {
      return true;
    }

    return false;
  },
};

export default customerDetails;
